<template>
  <div :class="`col-md-${width} form-group`">
    <label v-if="label" class="control-label">{{ `${label} ${required ? '*' : ''}` }}</label>
    <p v-if="help" class="help-block">{{ help }}</p>

    <select :ref="`select-${name}`" class="form-control" :id="name" :name="name" :required="required" :disabled="disabled" @input="$emit('input', $event.target.value)">
      <option value=""></option>
      <option v-for="option in options" :key="option.value" :value="option.value" :selected="option.value == value">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '12' },
    placeholder: { type: String, default: '' },
    value: { type: String | Number, default: '' },
    name: { type: String, required: true },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    options: { type: Array, required: true },
    label: String,
    help: String,
  },
  mounted() {
    this.initializeSelect2();
  },
  methods: {
    initializeSelect2() {
      const selectElement = this.$refs[`select-${this.name}`];
      $(selectElement).select2({
        placeholder: this.placeholder || "Seleziona un'opzione",
        allowClear: true,
      });

      $(selectElement).on('change', () => {
        this.$emit('input', selectElement.value);
      });
    },
  },
  watch: {
    options: {
      handler(newOptions) {
        this.$nextTick(() => {
          const select = this.$refs[`select-${this.name}`];
          $(select).empty();
          newOptions.forEach((option) => {
            $(select).append(new Option(option.label, option.value, option.value === this.value));
          });
          $(select).val(this.value);
        });
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/inputs/select.vue